import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { DialogTypeEnum } from 'src/app/dashboard/interfaces/DialogType';
import { ActivityTypesEnum } from 'src/app/shared/interfaces/ActivityTypesEnum';
import { IAdjustmentPayload } from 'src/app/shared/interfaces/IAdjustmentPayload';
import { InventoryState } from 'src/app/shared/states/inventory/inventory.state';
import { TransactionsState } from 'src/app/shared/states/transactions/transactions.state';
import { IAuditDetailFormRaw } from '../../interfaces/IAuditDetailFormRaw';
import { PharmacyState } from 'src/app/shared/states/pharmacy/pharmacy.state';

@Component({
  selector: 'app-audit-details-adjustments-transaction',
  templateUrl: './audit-details-adjustments-transaction.component.html',
  styleUrls: ['./audit-details-adjustments-transaction.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuditDetailsAdjustmentsTransactionComponent implements OnChanges {
  
  @ViewChild('transactionsMenu') transactionsMenu;
  
  @Input() detail: IAuditDetailFormRaw;
  @Input() onHand: number;
  @Input() discrepancy: number;
  
  @Output() adjustmentAdded: EventEmitter<IAdjustmentPayload> = new EventEmitter();
  @Output() noteOtherReasonOptionSelected: EventEmitter<void> = new EventEmitter();

  showDispenseDialog: boolean;
  showReceiveDialog: boolean;
  showRecordLostDialog: boolean;
  showDamagedOrExpiredDialog: boolean;
  showMoveInventoryDialog: boolean;
  
  adjustmentQtyInvalid: boolean;
  
  DialogTypeEnum = DialogTypeEnum;
  
  maxValueExceededErrorMessage: string = 'Quantity cannot be greater than discrepancy.';

  displayDeductInventoryActions: boolean;
  displayDamagedExpired: boolean;
  
  @Select(TransactionsState.success) success$: Observable<boolean>;
  @Select(PharmacyState.inventoryLocationsEnabled) inventoryLocationsEnabled$: Observable<boolean>;
  
  private activityType: ActivityTypesEnum;

  /**
   *
   */
  constructor(private store: Store) {
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.displayDeductInventoryActions = +this.detail?.actualCount - +this.detail?.initialInventoryCount < 0;
    this.displayDamagedExpired = this.detail.inventoryLocationID !== this.store.selectSnapshot(InventoryState.damagedExpiredLocationID);
  }

  dispenseDrug = (formValue) => {
    this.activityType = ActivityTypesEnum.Dispensed; 
    this.sendTransaction(formValue);
    this.showDispenseDialog = false;
  }
  
  receiveDrug = (formValue) => {
    this.activityType = ActivityTypesEnum.Received;
    this.sendTransaction(formValue);
    this.showReceiveDialog = false;
  }

  recordLostOrStolenDrug = (formValue) => {
    this.activityType = ActivityTypesEnum.LostStolen;
    this.sendTransaction(formValue);
    this.showRecordLostDialog = false;
  }

  recordDamagedOrExpiredDrug = (formValue) => {
    this.activityType = ActivityTypesEnum.DamagedExpired;
    this.sendTransaction(formValue);
    this.showDamagedOrExpiredDialog = false;
  }

  sendTransaction(formValue) {
    const adjustment = {...formValue,
      activityType: this.activityType,
      auditDetailId: this.detail?.id,
      addedQuantity: formValue?.drugs[0]?.addedQuantity,
      drugId: formValue?.drugs[0]?.drugId,
      friendlyName: formValue?.drugs[0]?.friendlyName,
      purchaseOrderNumber: formValue?.poNumber, 
      wholesalerId: formValue?.wholesaler?.id,
      invoiceNumber: formValue?.invoiceNumber,
      shipDate: formValue?.shipDate,
      note: formValue?.drugs[0]?.note,
      transactionDate: formValue.transactionDate,
      fillNumber: formValue.fillNumber,
      csos: formValue?.csos,
      supplierDetailsID: formValue?.supplierDetailId,
      buyerDetailsID: formValue?.buyerDetailId
    }
    this.adjustmentAdded.emit(adjustment);
  }

  onInputValueChanged(qty: number): void {
    this.adjustmentQtyInvalid = Math.abs(qty) > Math.abs(this.detail?.initialInventoryCount - +this.detail?.actualCount);
  }

  openTransactionDialog(varToOpenDialog: string, event: Event): void {
    this[varToOpenDialog] = true;
    this.transactionsMenu?.close();
    event.stopPropagation();
  }

  positionMenuContent(): string {
    const elementRect = this.transactionsMenu?.elementRef.nativeElement.getBoundingClientRect();
    const spaceBelow = window.innerHeight - elementRect?.bottom;

    if(spaceBelow < 200)
      return 'top-right';
    
    return 'bottom-right';
  }

  composeDrug(): any {
    return {...this.detail, drugID: this.detail?.drugId, packageNdc: this.detail?.packageNDC11Digit, maxQty: Math.abs(this.discrepancy),
      similarOnHand: this.detail.availableSOH
    };
  }

  getLocationIDsToExclude(): string [] {
    return this.store.selectSnapshot(InventoryState.activeLocations)?.filter(x => x?.id !== this.detail?.inventoryLocationID)?.map(x => x?.id);
  }
}
